import React from "react";

import EditCartEmployeesModal from "EmployerApplication/Components/EditCartEmployees/EditCartEmployeesModal";
import PayrollContributionTable from "EmployerApplication/Components/PayrollContributionTable";
import { cleanEmployeeProfile } from "EmployerApplication/CostEstimationUtils";
import { useFormState } from "react-final-form";
import { connect, useSelector } from "react-redux";
import simplifyPlanName from "Utils/simplifyPlanName";

import { TitleSmall } from "Cobalt/Header";
import { getSelectedMedicalPlans, getSelectedDentalPlan, getSelectedVisionPlan, getCart } from "Common/CartService";
import { Div } from "Common/HTML";
import InfoPopover from "Common/InfoPopover";
import { Body2 } from "Theme/BodyText";

export const PayrollContributionSectionDumb = ({ employeesCosts, showMultiplePlansDisclaimer, baseMedicalPlan, popoverInfoText }) => {
  let contributions;
  const employeeProfile = useSelector((state) => state.employeeProfile);

  const formValues = useFormState().values;
  const contributionMethod = formValues.company_application.contribution_method;

  if (contributionMethod === "tiered") {
    contributions = formValues.tiered_contributions.filter((contribution) => !!contribution.role);
  } else {
    contributions = [
      {
        employeePercentage: formValues.company_contribution.employee_percentage,
        dependentPercentage: formValues.company_contribution.dependent_percentage,
        employeeFixedAmount: formValues.company_contribution.employee_fixed_amount,
        dependentFixedAmount: formValues.company_contribution.dependent_fixed_amount,
      },
    ];
  }

  const contributionType = formValues.company_application.type_of_contribution;

  return (
    <>
      <Div m={0} className="min-h-10 justify-between flex flex-row items-center">
        <TitleSmall>
          Cost Breakdown
          {popoverInfoText && <InfoPopover triggerText="More" className="SIFormLabel__Guidance sm:ml-4 xs:ml-2" infoText={popoverInfoText} placement="right" />}
        </TitleSmall>
        <Div className="text-right">
          <EditCartEmployeesModal contributionType={contributionType} contributions={contributions} triggerText="Edit Employees" />
        </Div>
      </Div>
      <PayrollContributionTable
        employeeProfiles={employeeProfile}
        contributionType={contributionType}
        employeesCosts={employeesCosts}
        contributions={contributions}
        showMultiplePlansDisclaimer={showMultiplePlansDisclaimer}
      />

      {showMultiplePlansDisclaimer && cleanEmployeeProfile(employeeProfile).length > 0 && employeesCosts.length > 0 ? (
        <Body2 className="text-right">*Costs reflect employee enrollment in {simplifyPlanName(baseMedicalPlan)} and all other lines of coverage</Body2>
      ) : (
        <Body2 className="text-right">*Costs reflect employee enrollment in all lines of coverage</Body2>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const medicalPlans = getSelectedMedicalPlans(state);
  const dentalPlan = getSelectedDentalPlan(state);
  const visionPlan = getSelectedVisionPlan(state);
  const baseMedicalPlan = medicalPlans[0];
  const showMultiplePlansDisclaimer = getSelectedMedicalPlans(state).length > 1;
  const employeesCosts = baseMedicalPlan?.employee_costs || [];

  return {
    employeesCosts,
    showMultiplePlansDisclaimer,
    baseMedicalPlan,
    medicalPlans,
    dentalPlan,
    visionPlan,
  };
};

const withRedux = connect(mapStateToProps);

const PayrollContributionSection = withRedux(PayrollContributionSectionDumb);

export default PayrollContributionSection;
